module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB2001-2c803e3187ecc9115cbb7c1ed31de1d0.png";